<template>
  <div class="mobile-nav">
    <div @click="showDrawer" class="mobile-nav__toggle">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <a-drawer
      :body-style="{ padding: '0' }"
      :drawer-style="{ overflow: 'hidden' }"
      :closable="false"
      :visible="visible"
      :zIndex="999"
      placement="right"
      width="320"
      wrapClassName="mobile-nav__drawer"
      @close="onClose"
    >
      <div class="mobile-nav__header">
        <div class="mobile-nav-contact">
          <a
            title="71 771 76 21"
            href="tel:717717621"
            class="mobile-nav__phone"
          >
            <div class="mobile-nav__phone-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 32 32"
              >
                <path
                  fill="#00a1fe"
                  d="M29.5 15.4c-1-6.3-6.1-12-13.3-13l.3-2.4A18.3 18.3 0 0132 15l-2.5.4zm-4 0l-2.4.5a8.5 8.5 0 00-7.3-7l.4-2.5a11 11 0 019.3 9zM16.4 23c1.5.9 1.9 1 2.2.7l2.3-2.4c1-1 2.4-1 3.4 0l3.8 3.8c1.1 1 1 2.4 0 3.4L26 30.6a4.3 4.3 0 01-3.7 1.4c-2-.1-4-.8-5.8-1.7A32 32 0 01.9 13.6C.3 12-.1 10.5 0 8.8 0 7.8.5 7 1.2 6.2l2.4-2.4c1-1 2.3-1 3.4 0l3.8 3.8c1 1.1 1 2.4 0 3.5l-2.4 2.3s-1 .4 2 4c1.7 2.2 3.7 4 6 5.5z"
                />
              </svg>
            </div>
            <span class="mobile-nav__phone-number">71 771 76 21</span>
          </a>
        </div>
        <div @click="onClose" class="mobile-nav__close">
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="mobile-nav__body">
        <ul role="menu" class="unstyled-list">
          <li role="menuitem" v-for="(parentItem, idx) in items" :key="idx">
            <div class="mobile-nav__menu-root-item mobile-nav__menu-item">
              <a
                :href="parentItem.item[0].link"
                :class="{ _active: toggle.indexOf(idx) >= 0 }"
                class="d-flex font-m"
              >
                <span
                  v-if="parentItem.item[0].nazwa == 'Wczasy w Polsce'"
                  class="mobile-nav__prefix-icon d-inline-flex mr-8"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 23.61 25"
                    width="20"
                    height="21"
                  >
                    <path
                      fill="#fff"
                      d="M22.51 4.63c0-.35-.29-.64-.64-.64H11.79V1.46c0-.12-.06-.23-.15-.29-.06-.04-.13-.06-.2-.06-.04 0-.09 0-.13.02l-9.8 3.81c-.25.1-.41.33-.41.6v6.53h21.41V4.63Z"
                    />
                    <path
                      fill="red"
                      d="M21.87 2.89h-8.98V1.46c0-.48-.24-.93-.64-1.2-.11-.08-.24-.13-.36-.17l-.12-.03c-.09-.02-.18-.04-.27-.04-.02 0-.04-.01-.07-.01-.02 0-.04.01-.06.01-.16 0-.32.03-.47.09l-9.79 3.8C.44 4.17 0 4.81 0 5.53v11.09c0 .65.36 1.25.94 1.55l12.83 6.63c.25.13.52.19.8.19.38 0 .76-.13 1.07-.36l7.31-5.64c.43-.33.68-.83.68-1.38V4.63c0-.96-.78-1.74-1.74-1.74ZM1.1 5.54c0-.27.16-.5.41-.6l9.79-3.82s.09-.02.13-.02c.07 0 .14.02.2.06.1.07.15.18.15.29v2.54h10.08c.35 0 .64.29.64.64v7.44H1.1V5.54Z"
                    />
                  </svg>
                </span>

                {{ parentItem.item[0].nazwa }}</a
              >
              <span
                v-if="parentItem.item.length > 1"
                class="mobile-nav__submenu-toggle"
                :class="{ _open: toggle.indexOf(idx) >= 0 }"
                @click="toggleItem(idx)"
              ></span>
            </div>
            <ul
              v-if="parentItem.item.length > 1"
              class="mobile-nav__submenu collapsible unstyled-list"
              role="menu"
              :class="{ _open: toggle.indexOf(idx) >= 0 }"
            >
              <li
                role="menuitem"
                v-for="(subItem, idx2) in parentItem.item"
                v-bind:key="idx2"
              >
                <div v-if="idx2 != 0" class="mobile-nav__menu-item">
                  <a :href="subItem.link">{{ subItem.nazwa }}</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="mobile-nav__footer-menu unstyled-list">
          <li>
            <a class="gray-70" href="/o-nas" title="O nas">O nas</a>
          </li>
          <li>
            <a class="gray-70" href="/kontakt" title="Kontakt">Kontakt</a>
          </li>
          <li>
            <a class="gray-70" href="/rodzaj-oferty.xml" title="Kategorie"
              >Kategorie</a
            >
          </li>
          <li>
            <a
              class="gray-70"
              href="https://www.travelone.pl/warunki/regulamin_korzystania_z_serwisu_t1.pdf"
              title="Regulamin"
              >Regulamin</a
            >
          </li>
          <li>
            <a
              class="gray-70"
              href="https://www.travelone.pl/warunki/polityka_prywatnosci_t1.pdf"
              title="Polityka prywatności"
              >Polityka prywatności</a
            >
          </li>
          <li>
            <a class="gray-70" href="/mapa-serwisu.xml" title="Mapa serwisu"
              >Mapa serwisu</a
            >
          </li>
        </ul>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { zakladki } from "../zakladki.js";

export default {
  name: "mobile-navigation",
  data: () => ({
    items: zakladki.zakladki.items,
    toggle: [],
    visible: false,
  }),
  methods: {
    toggleItem: function (key) {
      var i = this.toggle.indexOf(key);
      if (i < 0) {
        this.toggle.push(key);
      } else {
        this.toggle.splice(i, 1);
      }
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-nav {
  margin-left: 16px;

  &__body {
    overflow-y: auto;
    height: calc(100vh - 88px);
    padding: 0 12px;
  }

  &__header {
    border-bottom: 1px solid $gray-20;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    margin: 0 12px 12px;
    padding: 12px 0;
    position: relative;
  }

  &__toggle,
  &__close {
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 40px;
    width: 40px;
    transition: all linear 0.15s;

    > span {
      display: block;
      width: 24px;
      height: 2px;
    }
  }

  &__toggle {
    &:active {
      background-color: darken($blue-dark, 10%);
    }

    > span {
      background-color: #fff;
      margin: 3px auto;
    }
  }

  &__close {
    &:active {
      background-color: $gray-10;
    }

    > span {
      background-color: $gray-30;
      margin: -1px auto;

      &:first-of-type {
        transform: rotate(45deg);
      }
      &:last-of-type {
        transform: rotate(-45deg);
      }
    }
  }

  &__contact {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__phone {
    color: $text-color-default;
    display: flex;
    margin-left: auto;
    height: 30px;
    line-height: 32px;
  }

  &__phone-icon {
    margin: auto 0;
    width: 24px;
    height: 24px;
  }

  &__phone-number {
    font-size: 24px;
    margin-left: 12px;
  }

  &__submenu-toggle {
    border-radius: 50%;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
    width: 30px;
    height: 30px;
    transition: all linear 0.1s;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
    }

    &:active {
      background-color: lighten($gray-10, 2%);
    }

    &:before,
    &:after {
      background-color: $blue-light;
      transition: all linear 0.1s;
    }

    &:before {
      width: 2px;
      height: 12px;
    }

    &:after {
      width: 12px;
      height: 2px;
    }

    &._open {
      &:before {
        height: 2px;
      }
    }
  }

  &__menu-root-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
  }

  &__menu-item {
    padding: 6px 0;

    > a {
      color: $text-color-default;

      &._active {
        color: $blue-light;
      }
    }
  }

  &__submenu {
    padding-left: 12px;

    &.collapsible {
      max-height: 0;
      overflow: hidden;
      transition: max-height ease-out 0.25s;
    }

    &._open {
      max-height: 1000px;
      transition: max-height ease-in 0.25s;
    }
  }

  &__footer-menu {
    border-top: 1px solid $gray-20;
    margin-top: 16px;
    padding-top: 16px;

    > li {
      font-size: 15px;
      padding: 6px 0;
    }
  }
}
</style>
